import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { Button, Col, Row, Typography } from 'components';
import { HasAccess } from 'components/common/accessControl';
import { EditIcon, WarehouseIcon } from 'components/common/icons';
import styles from './styles.module.scss';
import { WarehouseType } from '..';

const { Text } = Typography;

interface IWarehouseCard {
  data: WarehouseType;
  onEdit: () => void;
}

export const WarehouseCard = React.memo((props: IWarehouseCard) => {
  const { data, onEdit } = props;
  return (
    <Row className={styles.warehouse_card}>
      <Col span={24}>
        <Row className={'gap-4'} justify={'space-between'}>
          <Col>
            <Row align={'middle'} className={'gap-4'}>
              <WarehouseIcon />
              <Col>
                <Text className={'font-size-16 font-weight-500'}>
                  {data.city} {data.name}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <HasAccess role={PERMISSIONS.countries.warehouse.write}>
                <Button title={'Edit'} type={'link'} size={'small'} icon={<EditIcon />} onClick={onEdit} />
              </HasAccess>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col style={{ marginLeft: '22px' }}>
        <Text className={'font-size-16'}>
          {data.state} {data.streetAddress} {data.zip}
        </Text>
      </Col>
    </Row>
  );
});
